// extracted by mini-css-extract-plugin
module.exports = {"content":"ResetPassword_content__3IwCr","field":"ResetPassword_field__3lrgo","passwordDesc":"ResetPassword_passwordDesc__1kMqY","submit":"ResetPassword_submit__2bRC5"};